export default function Loader(){
    return <div className="flex items-center justify-center h-screen w-screen bg-white">
    <div className="w-20 h-20 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
  </div>
}